// Vite error handler - reload the page when loading a chunk fails
// This is needed because we released a new version and it doesn't exist anymore
// Reference: https://github.com/vitejs/vite/issues/11804
window.addEventListener('vite:preloadError', () => window.location.reload());
